export default "__VITE_ASSET__b803dc6e__"